import {
  ChangeDetectorRef,
  Component,
  OnInit,
  Output,
  EventEmitter,
} from "@angular/core";
import { Banner } from "src/app/shared/models/dashboard.model";
import { BroshService } from "src/app/shared/services/brosh.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { UploadService } from "src/app/shared/services/upload.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { FileUpload } from "src/app/shared/models/common";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/shared/services/auth.service";
import { Store } from "@ngrx/store";
import { dashboardData } from "src/app/shared/ngrx/ngrx-selectors";
import { REQUEST_DASHBOARD_REFRESH } from "src/app/shared/ngrx/ngrx-actions";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SelectModule } from "primeng/select";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { DatePickerModule } from "primeng/datepicker";
import { SpinnerComponent } from "src/app/shared/components/ui/spinner/spinner.component";

@Component({
  selector: "edit-banners",
  templateUrl: "./edit-banners.component.html",
  styleUrls: ["./edit-banners.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    SelectModule,
    DatePickerModule,
    SpinnerComponent,
  ],
  standalone: true,
})
export class EditBannersComponent implements OnInit {
  @Output() onCancel = new EventEmitter();
  data: Banner[] = [];
  saving: boolean;
  isUploading: boolean;
  isValidFile: boolean = undefined;
  invalidFileWarn: string;
  uplSubscription: Subscription;

  constructor(
    private readonly store: Store,
    private broshService: BroshService,
    private uploadService: UploadService,
    private authService: AuthService,
    private sharedService: SharedService,
    // the hosting dash-banners is OnPush; async writes here must mark the path
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.data = JSON.parse(
      JSON.stringify(this.store.selectSignal(dashboardData)().banners)
    );

    this.data.forEach((b) => {
      b.validUntilDate = this.store
        .selectSignal(dashboardData)()
        .banners.find((c) => c.contentId == b.contentId).validUntilDate;
    });
  }

  public closePanel() {
    this.onCancel.emit();
  }

  save() {
    this.saving = true;
    this.broshService.updateDashboardBanners(this.data).subscribe(
      () => {
        this.saving = false;
        this.store.dispatch(REQUEST_DASHBOARD_REFRESH());

        this.closePanel();
        this.cdr.markForCheck();
      },
      () => {
        this.saving = false;
        this.cdr.markForCheck();
      }
    );
  }

  uploadFile($event, fileType: string = null) {
    const fileData: File = $event.target.files[0];
    if (!fileData) return;
    this.isValidFile = undefined;

    this.isValidFile = this.uploadService.validateFile(fileData, "jpg");
    if (!this.isValidFile) {
      this.invalidFileWarn = this.uploadService.fileInvalidAlert;
      return;
    }
    this.isUploading = true;

    const file: FileUpload = new FileUpload();
    file.fileType = this.uploadService.getFileType(fileData);
    file.subFolder = SharedService.bannerSubFolder;

    (async () => {
      await this.uploadService.uploadFile(fileData);
      file.file = fileData;

      this.uplSubscription = this.uploadService
        .getPresignedUrl(file, true)
        .subscribe(
          (data) => {
            this.uploadService.putFile(file, data.uploadUrl).subscribe(
              (res) => {
                this.uploadService.copyUploadFile(data.s3Key).subscribe(
                  (res) => {
                    let newBanner = new Banner();
                    newBanner.imgUrl =
                      SharedService.filesBucketUrl + data.s3Key;
                    this.data.push(newBanner);
                    this.isUploading = false;
                    this.cdr.markForCheck();
                  },
                  (err) => {
                    this.sharedService.alertError(err);
                    this.isUploading = false;
                    this.cdr.markForCheck();
                  }
                );
              },
              (err) => {
                this.sharedService.alertError(err);
                this.isUploading = false;
                this.cdr.markForCheck();
              }
            );
          },
          (err) => {
            this.sharedService.alertError(err);
            this.isUploading = false;
            this.cdr.markForCheck();
          }
        );
    })();

    $event.target.value = "";
  }

  deleteItem(item: Banner) {
    this.data.splice(this.data.indexOf(item), 1);
  }

  drop(event: any) {
    moveItemInArray(this.data, event.previousIndex, event.currentIndex);
  }
}
